import axios from 'axios';

export default class DaxHttpService {

    async format(string, settings) {
        let postData = {
            string: string,
            settings: settings
        };
        return await axios.post('/api/dax', postData);
    }
}
